import { Button, SelectWithSearch } from "components";
import FilterLabel from "modules/shared/profiles/filters/FilterLabel";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ButtonRow } from "styles/elements/main";
import { getAllBoxTypes, getAllTruckTypes, getAllYears } from "../api";
import { QA_STATUS } from "../staticData";
import { useMapDataToUiWithFilter } from "hooks/mapDataToOptions";
import trackAnalytics from "trackAnalytics";

const Container = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
`;

function TrucksFilter({ setTrucksFilterOptinos, filterOptions }) {
    const [filtersData, setFiltersData] = useState({});
    const [totalFilters, setTotalFilters] = useState(0);
    const [allTruckClass, setTruckClass] = useState(null);
    const [allBoxesType, setAllBoxesType] = useState(null);
    const [allYears, setAllYears] = useState(null);
    const {
        data: allSuppliers,
        setSearchFilter: setSuppliersFilter,
        clearSearchFilter: clearSuppliersFilter,
    } = useMapDataToUiWithFilter("suppliers");

    const analyticsEvents = {
        truckClass: "Filter_truck_by_class_clicked",
        truckTypeId: "Filter_truck_by_type_clicked",
        supplierId: "Filter_truck_by_supplier_clicked",
        year: "Filter_truck_by_manufacturing_year_clicked",
        qaStatus: "Filter_truck_by_status_clicked",
    };

    const handleGetTruckClass = async () => {
        const data = await getAllTruckTypes();
        setTruckClass(
            data.map((name) => ({
                value: name,
                label: name,
            }))
        );
    };

    const handleGetBoxTypes = async (truckClass) => {
        const data = await getAllBoxTypes(truckClass);
        setAllBoxesType(data);
    };

    const handleGetYears = async () => {
        const data = await getAllYears();
        setAllYears(data.map((name) => ({ label: name, value: name })));
    };
    const handleApplyFilter = (name, newFilters) => {
        const applyedOptions = [];
        let filterValues = [];
        const updatedFilters = newFilters || filtersData;
        for (const option in updatedFilters) {
            const filter = updatedFilters[option];
            filterValues = filter.value.map((element) => element.label);
            applyedOptions.push({ ...updatedFilters, [option]: filter });
        }
        if (analyticsEvents[name]) {
            trackAnalytics(analyticsEvents[name], {
                "Filter Value": filterValues,
            });
        }
        setTrucksFilterOptinos(applyedOptions);
    };

    const handleFiltersDataChange = (name, value) => {
        const newFilters = {
            ...filtersData,
            [name]: { value },
        };
        setFiltersData(newFilters);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < filterOptions?.length; i++) {
            if (newFilters[name]?.value?.length < filterOptions[i][name]?.value?.length) {
                handleApplyFilter(name, newFilters);
            }
        }
    };

    const handleClearSingleFilter = (filterName) => {
        const filtered = { ...filterOptions[0] };
        delete filtered[filterName];
        setFiltersData((prev) => ({ ...prev, [filterName]: { value: [] } }));
        setTrucksFilterOptinos([filtered]);
    };

    const handelClearAllFilters = () => {
        const updatedFilters = {};
        for (const filter in filtersData) {
            updatedFilters[filter] = { value: [] };
        }
        setFiltersData(updatedFilters);
        setTrucksFilterOptinos([]);
    };

    const ActionsButtons = ({ name }) => (
        <ButtonRow>
            <Button
                name="Clear"
                type="button"
                btnStyle="secondBtn"
                onChange={() => handleClearSingleFilter(name)}
            />
            <Button
                name="Apply"
                type="button"
                btnStyle="primaryBtn"
                onChange={() => handleApplyFilter(name)}
            />
        </ButtonRow>
    );

    useEffect(() => {
        if (filtersData.truckClass?.value[0]?.value) {
            let classes = filtersData.truckClass.value.map((element) => element.value);
            handleGetBoxTypes(classes);
        } else {
            setAllBoxesType([]);
        }
    }, [filtersData?.truckClass]);

    useEffect(() => {
        const sum = Object?.values(filtersData)?.reduce(
            (acc, curr) => acc + curr?.value?.length,
            0
        );
        setTotalFilters(sum);
    }, [filterOptions]);

    useEffect(() => {
        handleGetTruckClass();
        handleGetYears();
    }, []);
    return (
        <>
            <FilterLabel
                handelClearAllFilters={handelClearAllFilters}
                filtersCount={totalFilters}
            />
            <Container>
                <SelectWithSearch
                    placeholder="Class"
                    name="truckClass"
                    isEditable
                    handleChange={(value) => handleFiltersDataChange("truckClass", value)}
                    isMulti
                    customBtns={<ActionsButtons name="truckClass" />}
                    options={allTruckClass}
                    value={filtersData?.truckClass?.value}
                />

                <SelectWithSearch
                    placeholder="Type"
                    name="truckTypeId"
                    isEditable
                    handleChange={(value) => handleFiltersDataChange("truckTypeId", value)}
                    isMulti
                    customBtns={<ActionsButtons name="truckTypeId" />}
                    options={allBoxesType}
                    value={filtersData?.truckTypeId?.value}
                    disable={!filtersData?.truckClass?.value[0]?.value}
                />
                <SelectWithSearch
                    placeholder="Supplier"
                    name="supplierId"
                    isEditable
                    handleChange={(value) => handleFiltersDataChange("supplierId", value)}
                    isMulti
                    customBtns={<ActionsButtons name="supplierId" />}
                    options={allSuppliers}
                    value={filtersData?.supplierId?.value}
                    handleFilter={(filter) => {
                        setSuppliersFilter(filter);
                        return allSuppliers;
                    }}
                    onMenuClose={() => clearSuppliersFilter()}
                />
                <SelectWithSearch
                    placeholder="Manufacturing year"
                    name="year"
                    isEditable
                    handleChange={(value) => handleFiltersDataChange("year", value)}
                    isMulti
                    customBtns={<ActionsButtons name="year" />}
                    value={filtersData?.year?.value}
                    options={allYears}
                />
                <SelectWithSearch
                    placeholder="Statuses"
                    name="qaStatus"
                    isEditable
                    handleChange={(value) => handleFiltersDataChange("qaStatus", value)}
                    isMulti
                    customBtns={<ActionsButtons name="qaStatus" />}
                    options={QA_STATUS}
                    value={filtersData?.qaStatus?.value}
                />
            </Container>
        </>
    );
}

export default TrucksFilter;
